import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {VexModule} from '../@vex/vex.module';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import {CustomLayoutModule} from './custom-layout/custom-layout.module';
import {JwtModule} from '@auth0/angular-jwt';
import {environment} from "../environments/environment";
import {TranslateModule} from '@ngx-translate/core';
import {provideTranslateHttpLoader} from '@ngx-translate/http-loader';
import {
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
  MatMomentDateModule,
  MomentDateAdapter
} from '@angular/material-moment-adapter';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MAT_DATE_LOCALE, DateAdapter, MAT_DATE_FORMATS} from '@angular/material/core';
import {MatButtonModule} from "@angular/material/button";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";
import {ReactiveFormsModule} from "@angular/forms";
import {FileManagerComponent} from './pages/files/file-manager/file-manager.component';
import {BreadcrumbsModule} from "../@vex/components/breadcrumbs/breadcrumbs.module";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatIconModule} from "@angular/material/icon";
import {MatMenuModule} from "@angular/material/menu";
import {MatPaginatorModule} from "@angular/material/paginator";
import {MatSortModule} from "@angular/material/sort";
import {MatTableModule} from "@angular/material/table";
import {MatTooltipModule} from "@angular/material/tooltip";
import {PageLayoutModule} from "../@vex/components/page-layout/page-layout.module";
import {MatProgressBarModule} from "@angular/material/progress-bar";
import {CdkDrag, CdkDropList} from "@angular/cdk/drag-drop";
import {ClipboardModule} from "@angular/cdk/clipboard";
import 'froala-editor/js/plugins.pkgd.min.js';
import {FroalaEditorModule} from "./components/editors/froala-editor/froala-editor.module";
import {MatSnackBarModule} from "@angular/material/snack-bar";
import {WikiHelpLinkComponent} from "./components/wiki-help-link/wiki-help-link.component";
import {DashboardModule} from "./pages/dashboard/dashboard.module";
import {TooltipModule} from "primeng/tooltip";

export function tokenGetter() {
  return localStorage.getItem("access_token");
}

export const MY_FORMATS = {
  parse: {
    dateInput: 'YYYY-MM-DD'
  },
  display: {
    dateInput: 'DD.MM.YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY'
  }
};


@NgModule({ declarations: [AppComponent, FileManagerComponent],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        MatMomentDateModule,
        TranslateModule.forRoot(),
        JwtModule.forRoot({
            config: {
                tokenGetter: tokenGetter,
                allowedDomains: [environment.api.allowedUrl],
                disallowedRoutes: [`${environment.api.url}/login_check`],
            },
        }),
        // Vex
        VexModule,
        CustomLayoutModule,
        MatButtonModule,
        MatDatepickerModule,
        MatFormFieldModule,
        MatInputModule,
        ReactiveFormsModule,
        BreadcrumbsModule,
        MatCheckboxModule,
        MatIconModule,
        MatMenuModule,
        MatPaginatorModule,
        MatSortModule,
        MatTableModule,
        MatTooltipModule,
        PageLayoutModule,
        MatProgressBarModule,
        CdkDrag,
        CdkDropList,
        ClipboardModule,
        FroalaEditorModule,
        MatSnackBarModule,
        WikiHelpLinkComponent,
        DashboardModule,
        TooltipModule], providers: [
        MatDatepickerModule,
        { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
        },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
        provideHttpClient(withInterceptorsFromDi()),
        provideTranslateHttpLoader({ prefix: './assets/i18n/', suffix: '.json' }),
    ] })
export class AppModule {
}
